<template>
  <AdminLayout :title="$t('admin_ads.ads_manage_title')" :current="$c.ADMIN.TAB.ADS">
    <div class="section">
      <div class="container" style="padding-bottom: 1em!important;">
        <p class="caption_label">{{$t('admin_ads.main_content_detail')}}</p>
        <div class="unit">
          <b-form-textarea
            class="mb-3"
            v-if="w_type"
            id="textarea"
            v-model="home_content_text"
            rows="3"
            max-rows="5"
            style="height: 80px;"
          ></b-form-textarea>
          <div class="mb-3 admin-border" v-else style="height: 80px;display: flex; align-items: center; justify-content: center;" @click="on_write_img">
            <b-img v-if="home_content_image !== ''" ref="prev-img" :src="home_content_image" style="margin:auto;width: 100%; height: 100%;"></b-img>
            <div style="text-align: center" v-else v-html="$t('admin_ads.main_content_hint')+$t('admin_ads.main_image_size_hint')+' 80 X 240'"></div>
          </div>
          <div class="leftright">
            <div>
              <b-button variant="white" :pressed="w_type" @click="on_write_text" >{{$t('admin_ads.text')}}</b-button>
              <b-button variant="white"  :pressed="!w_type" @click="on_write_img" >{{$t('admin_ads.image')}}</b-button>
              <input @change="on_img_change" type="file" name="file" accept="image/*" ref="img-input" style="display: none" />
            </div>
            <b-button class="primary" @click="onApplyHomeData">{{$t('admin_ads.apply')}}</b-button>
          </div>
        </div>
        <p class="caption_label">{{$t('admin_ads.connect_detail')}}</p>
        <div class="unit leftright">
          <div>
            <b-button v-for="(item, k, i) in LINK_TYPE" variant="white" :pressed="item.key === home_connect_type"
                      @click="connect_changed(item.key)" style="margin-right: 0.5em;">{{item.title}}</b-button>
            <input @change="on_link_img_change" type="file" name="file" accept="image/*" ref="img-link" style="display: none" />

          </div>
          <b-button class="reset_btn" style="" @click="resetHomeData">{{$t('admin_ads.reset')}}</b-button>
        </div>
        <InputSearch inner_style="text-align: left" readonly type="string" v-model="home_search_hint" style="margin-top:2em"></InputSearch>
        <div class="unit leftright">
          <b-form-input class="admin-border" v-model="home_search_hint_temp" size="lg" style="flex:1; margin-right: 6px"></b-form-input>
          <b-button class="primary" @click="onApplySearchHint">{{$t('admin_ads.apply')}}</b-button>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <p class="caption_label">{{$t('admin_ads.advertising')}}</p>
        <div class="unit leftright">
          <div>
            <b-button v-for="item in AD_TYPE" variant="white" :pressed="view_mode === item.key"
                      @click="updateAdsViewMode(item.key)" style="margin-right: 0.5em;">{{item.title}}</b-button>
          </div>
          <b-dropdown :no-caret=true class="border" right variant="white" :text='adNumDisplay' style="width:25%;">
            <b-dropdown-item  v-for = "(option, i) in options" :key="i" @click="onShowAds(i)"
                              style="font-size: smaller;padding-left: 0.2em;">{{option.text}}</b-dropdown-item>
            <template #button-content>
              <div class="leftright" style="padding: 0 0.2em 0 0.2em; color: black; font-size: smaller">
                {{adNumDisplay}}
                <b-icon icon="chevron-down" font-scale="0.8"></b-icon>
              </div>
            </template>
          </b-dropdown>
        </div>
        <div id="preview_image"  class="pre-img-div">
          <b-img v-if="(currentAdsImageUrl !== '' &&  currentAdsImageUrl !== 'empty')" :src="currentAdsImageUrl" style="height: 100%; width: 100%"></b-img>
          <div v-else style="margin: auto">{{$t('admin_ads.ads_image_hint')}}</div>
        </div>
        <div class="unit" align=right>
          <input type="file" accept="image/*" @change="on_ads_img_change" style="display: none" ref="ads-img">
          <b-button @click="onRemoveAdsImage" class="delete_btn">{{$t('admin_ads.delete')}}</b-button>
          <b-button @click="onAttachAdsImage" class="reset_btn">{{$t('admin_ads.attach')}}</b-button>
        </div>
        <div class="unit">
          <b-row style="align-items:center; ">
            <b-col>
              <div class="leftright">
                <b-form-input v-model="ads_duration_sec" class="admin-border small" type="number" style="flex:1;margin-right: 8px" v-bind:placeholder='$t("admin_ads.duration_sec")'></b-form-input>
                <b-button @click="onApplyAdsDuration" class="primary">{{$t('common.apply1')}}</b-button>
              </div>
            </b-col>
            <b-col>
              <div class="leftright">
                <b-form-input v-model="currentAdsPeriodDay" class="admin-border small" type="number" style="flex:1;margin-right: 8px" v-bind:placeholder='$t("admin_ads.ad_period")'></b-form-input>
                <b-button @click="onApplyAdsPeriod" class="primary">{{$t('common.apply1')}}</b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <p class="caption_label">{{$t('admin_ads.connect_detail')}}</p>
        <div class="unit leftright">
          <div>
            <b-button v-for="(item , i) in LINK_TYPE" variant="white" :pressed="currentAdsConnectType === item.key"
                      @click="ads_connect_changed(item.key)" style="margin-right: 0.5em;">{{item.title}}</b-button>
          </div>
          <input type="file" accept="image/*" @change="on_ads_link_img_change" style="display: none" ref="ads-link-img">
          <b-button class="reset_btn1" style="" @click="resetAdsConnect">{{$t('admin_ads.reset')}}</b-button>
        </div>
      </div>
    </div>
    <b-modal
      content-class="md_modal_content"
      :title="$t('admin_ads.connect_detail')"
      :id="modal.id"
      footer-class="mo-footer"
      header-class="mo-header"
      v-for="modal in modals"
    >
      <div class="leftright">
        <div style="width: 18%">{{modal.key}}</div>
        <div style="width: 82%;"><b-input type="text" v-model="home_connect_data_display" style="text-align: right"></b-input></div>
      </div>
      <template slot="modal-header-close">
        <p class="h1"><b-icon icon="x"></b-icon></p>
      </template>
      <template slot="modal-footer">
        <b-button-group class="w-100" style="margin:0;font-size: 1.2em;">
          <b-button
            squared
            @click="cancel_modal(modal.id)"
            class="md_btn_light">{{$t('common.cancel')}}</b-button>
          <b-button
            squared
            @click="ok_modal(modal.id)"
            class="md_btn_primary">{{$t('common.ok')}}</b-button>
        </b-button-group>
      </template>
    </b-modal>
    <b-modal
      content-class="md_modal_content"
      :title="$t('admin_ads.connect_detail')"
      :id="modal.id"
      footer-class="mo-footer"
      header-class="mo-header"
      v-for="modal in ads_modals"
    >
      <div class="leftright">
        <div style="width: 18%">{{modal.key}}</div>
        <div style="width: 82%;"><b-input type="text" v-model="currentAdsConnectDataDisplay" style="text-align: right"></b-input></div>
      </div>
      <template slot="modal-header-close">
        <p class="h1"><b-icon icon="x"></b-icon></p>
      </template>
      <template slot="modal-footer">
        <b-button-group class="w-100" style="margin:0;font-size: 1.2em;">
          <b-button
            squared
            @click="cancel_modal(modal.id)"
            class="md_btn_light">{{$t('common.cancel')}}</b-button>
          <b-button
            squared
            @click="ok_ads_modal(modal.id)"
            class="md_btn_primary">{{$t('common.ok')}}</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
import i18n from "../../../../i18n";

const LINK_TYPE = {
  Sale:{title: i18n.t('admin.sale'), key:"S"},
  Community:{title: i18n.t('admin.community'), key:"C"},
  Image:{title: i18n.t('admin_ads.image'), key:"I"},
  Link:{title: i18n.t('admin_ads.link'), key:"L"},
}

const AD_TYPE = {
  SEQUENCE:{title: i18n.t('admin_ads.sequence'), key:"S"},
  RANDOM:{title: i18n.t('admin_ads.random'), key:"R"},
}

export default {
  name: "AdminAd",
  components: {
    AdminLayout,
    InputSearch
  },
  data() {
    return {
      LINK_TYPE: LINK_TYPE,
      AD_TYPE: AD_TYPE,
      home_content_image:null,
      text:null,
      home_search_hint: null,
      home_search_hint_temp: null,
      w_type: true,
      home_content_type: null,
      home_content_text:null,
      home_connect_data:null,
      home_connect_data_display:null,
      home_connect_type: null,
      view_mode: null,
      adNumDisplay: this.$t("admin_ads.ads_number"),
      currentAdsDisplayIdx: 0,
      currentAdsIdx: 0,
      currentAdsImageUrl: "",
      currentAdsConnectType: null,
      currentAdsConnectData: null,
      currentAdsConnectDataDisplay:null,
      adsList: [],
      ads_duration_sec: null,
      currentAdsPeriodDay: null,
      options: [
        { text: 'ADS 1' },
        { text: 'ADS 2' },
        { text: 'ADS 3' },
        { text: 'ADS 4' },
        { text: 'ADS 5' },
        { text: 'ADS 6' },
        { text: 'ADS 7' },
        { text: 'ADS 8' },
        { text: 'ADS 9' },
        { text: 'ADS 10' },
      ],
      modals:[
        {key: LINK_TYPE.Sale.title, id: "mo_sale"},
        {key: LINK_TYPE.Community.title, id: "mo_community"},
        {key: LINK_TYPE.Link.title, id: "mo_link"},
      ],
      ads_modals:[
        {key: LINK_TYPE.Sale.title, id: "ads_sale"},
        {key: LINK_TYPE.Community.title, id: "ads_community"},
        {key: LINK_TYPE.Link.title, id: "ads_link"},
      ],
    }
  },
  methods:{
    onShowAds(index) {
      this.$refs["ads-img"].value = null;
      this.adNumDisplay = this.options[index].text;
      this.currentAdsDisplayIdx = index;

      let adsItem = this.adsList.filter((it, idx) => {
        return it.f_idx == index + 1
      });
      adsItem = adsItem[0];
      if (Utils.isEmptyOrNull(adsItem)) {
        Utils.setState(this,{
          currentAdsIdx: index + 1,
          currentAdsImageUrl: '',
          currentAdsConnectType: LINK_TYPE.Sale.key,
          currentAdsPeriodDay: 0,
          currentAdsConnectData: '',
        });
        return;
      } else {
        Utils.setState(this,{
          currentAdsIdx: adsItem.f_idx,
          currentAdsImageUrl: adsItem.f_image_url,
          currentAdsConnectType: adsItem.f_connect_type,
          currentAdsPeriodDay: adsItem.f_period_day,
          currentAdsConnectData: adsItem.f_connect_value,
        });
      }
    },

    onRemoveAdsImage() {
      this.currentAdsImageUrl = "";
      this.updateAdsImage();
    },

    onAttachAdsImage() {
      if (this.currentAdsIdx < 1) {
        Utils.toast(this, this.$t('admin_ads.select_ads_hint'))
        return;
      }
      this.$refs["ads-img"].click();
    },
    on_write_img(){
      this.w_type=false;
      this.$refs['img-input'].click();
    },
    on_write_text(){
      this.w_type=true;
      this.$refs['img-input'].value = "";
    },
    on_ads_img_change(){
      var file = this.$refs['ads-img'].files[0];
      this.uploadImage(file, 'ads');
    },
    on_img_change(){
      var file = this.$refs['img-input'].files[0];
      this.uploadImage(file, 'home');
    },
    on_link_img_change(){
      var file = this.$refs['img-link'].files[0];
      this.uploadImage(file, 'link');
    },
    on_ads_link_img_change(){
      var file = this.$refs['ads-link-img'].files[0];
      this.uploadImage(file, 'ads-link');
    },

    connect_changed(key){
      this.home_connect_type = key;
      this.home_connect_data_display = null;
      switch (key){
        case LINK_TYPE.Sale.key: this.$bvModal.show('mo_sale'); break;
        case LINK_TYPE.Community.key: this.$bvModal.show('mo_community'); break;
        case LINK_TYPE.Image.key: this.$refs['img-link'].click(); break;
        case LINK_TYPE.Link.key: this.$bvModal.show('mo_link'); break;
      }
    },

    ads_connect_changed(key){
      this.currentAdsConnectType = key;
      this.currentAdsConnectDataDisplay = null;
      if (this.currentAdsIdx < 1) {
        Utils.toast(this, this.$t('admin_ads.select_ads_hint'))
        return;
      }

      switch (key){
        case LINK_TYPE.Sale.key: this.$bvModal.show('ads_sale'); break;
        case LINK_TYPE.Community.key: this.$bvModal.show('ads_community'); break;
        case LINK_TYPE.Image.key: this.$refs['ads-link-img'].click(); break;
        case LINK_TYPE.Link.key: this.$bvModal.show('ads_link'); break;
      }
    },
    ok_modal(id){
      if(this.home_connect_data_display == null){
        Utils.toast(this, this.$t('admin_ads.connect_content_input_hint'));
      }else{
        this.$bvModal.hide(id);
      }
    },
    ok_ads_modal(id){
      if(this.currentAdsConnectDataDisplay == null){
        Utils.toast(this, this.$t('admin_ads.connect_content_input_hint'));
        return;
      }
      this.currentAdsConnectData = this.currentAdsConnectDataDisplay;
      this.onApplyAdsConnectType();
      this.$bvModal.hide(id);
    },

    cancel_modal(id){
      this.home_connect_data_display = null;
      this.currentAdsConnectDataDisplay = null;
      this.$bvModal.hide(id);
    },
    uploadImage(file, type) {
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          switch (type){
            case 'home': this.home_content_image =  result.data.url; break;
            case 'link': this.home_connect_data =  result.data.url; break;
            case 'ads':
              this.currentAdsImageUrl =  result.data.url;
              this.adsList[this.currentAdsDisplayIdx].f_image_url = result.data.url;
              this.updateAdsImage();
              break;
            case 'ads-link':
              this.currentAdsConnectData = result.data.url;
              this.onApplyAdsConnectType();
              break;
          }
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    getHomeSetting() {
      Utils.requestGet(this.$c.API.Admin.getHomeSetting, {}).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.home_setting = result.data.home_setting;
          this.adsList = result.data.ads_list;
          this.w_type =  (result.data.home_setting.f_home_content_type === 'T');
          this.home_connect_type = result.data.home_setting.f_home_link_type;
          this.home_connect_data = result.data.home_setting.f_home_link_data;
          this.home_content_text = result.data.home_setting.f_home_content_type === 'T' ? result.data.home_setting.f_home_content  : '';
          this.home_content_image = result.data.home_setting.f_home_content_type === 'I' ? result.data.home_setting.f_home_content  : '';
          this.home_search_hint = result.data.home_setting.f_home_search_hint;
          this.ads_duration_sec = result.data.home_setting.f_ads_duration_sec;
          this.view_mode = result.data.home_setting.f_ads_mode;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onApplyHomeData() {
      if (this.home_connect_data_display != null)
        this.home_connect_data = this.home_connect_data_display;
      Utils.requestPost(this.$c.API.Admin.updateHomeSetting, {
        home_content_type: this.w_type? 'T': 'I',
        home_content: this.w_type ? this.home_content_text : this.home_content_image,
        home_link_type: this.home_connect_type,
        home_link_data: this.home_connect_data,
      }).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    resetHomeData() {
      Utils.requestGet(this.$c.API.Admin.getHomeSetting, {}).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.w_type = (result.data.home_setting.f_home_content_type === 'T');
          this.home_connect_type = result.data.home_setting.f_home_link_type;
          this.home_connect_data = result.data.home_setting.f_home_link_data;
          this.home_content_text = result.data.home_setting.f_home_content_type === 'T' ? result.data.home_setting.f_home_content : '';
          this.home_content_image = result.data.home_setting.f_home_content_type === 'I' ? result.data.home_setting.f_home_content : '';
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    onApplySearchHint() {
      Utils.requestPost(this.$c.API.Admin.updateAppInfo, {
        param_name: 'home_search_hint',
        value: this.home_search_hint_temp
      }).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.home_search_hint = this.home_search_hint_temp;
          this.home_search_hint_temp = null;
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onApplyAdsDuration() {
      if (Utils.isEmptyOrNull(this.ads_duration_sec)) {
        Utils.toast(this, this.$t('admin_ads.ad_duration_input_hint'));
        return;
      }
      Utils.requestPost(
        this.$c.API.Admin.updateAppInfo,
        {
          param_name: 'ads_duration_sec',
          value: this.ads_duration_sec
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          // this.myInfo.setting['ads_duration_sec'] = this.ads_duration_sec;
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    updateAdsViewMode(value) {
      this.view_mode = value;
      Utils.requestPost(
        this.$c.API.Admin.updateAppInfo,
        {
          param_name: 'ads_mode',
          value: value
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.view_mode = value;
          // this.myInfo.setting['ads_mode'] = value;
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onApplyAdsPeriod() {
      if (this.currentAdsIdx < 1) {
        Utils.toast(this, this.$t('admin_ads.select_ads_hint'))
        return;
      }
      if (Utils.isEmptyOrNull(this.currentAdsPeriodDay)) {
        Utils.toast(this, this.$t('admin_ads.ad_period_input_hint'))
        return;
      }
      Utils.requestPost(
        this.$c.API.Admin.updateAdsPeriod,
        {
          'ads_idx': this.currentAdsIdx,
          'period': this.currentAdsPeriodDay
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.adsList[this.currentAdsIdx - 1].f_period_day = this.currentAdsPeriodDay;
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onApplyAdsConnectType() {
      if (this.currentAdsIdx < 1) {
        Utils.toast(this, this.$t('admin_ads.select_ads_hint'))
        return;
      }
      Utils.requestPost(
        this.$c.API.Admin.updateAdsConnect,
        {
          'ads_idx': this.currentAdsIdx,
          'connect_type': this.currentAdsConnectType,
          'connect_value': this.currentAdsConnectData,
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.adsList[this.currentAdsIdx - 1].f_connect_type = this.currentAdsConnectType;
          this.adsList[this.currentAdsIdx - 1].f_connect_value = this.currentAdsConnectData;
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    updateAdsImage() {
      Utils.requestPost(this.$c.API.Admin.updateAdsImage, {
        'ads_idx': this.currentAdsIdx,
        'image_url': Utils.isEmptyOrNull(this.currentAdsImageUrl) ? "empty" : this.currentAdsImageUrl
      }).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if (this.adsList.some(it => {
            return it.f_idx == this.currentAdsIdx
          })) {
            if (Utils.isEmptyOrNull(this.currentAdsImageUrl)) {
              let idx_ = -1;
              this.adsList.forEach((it, idx) => {
                if (it.f_idx == this.currentAdsIdx)
                  idx_ = idx;
              })
              if (idx_ >= 0)
                this.adsList.splice(idx_,1);
            } else {
              this.adsList = this.adsList.map((it, idx) => {
                if(it.f_idx == this.currentAdsIdx)
                  return result.data;
                else
                  return it;
              });
            }
          } else {
            if (result.data)
              this.adsList.push(result.data);
          }
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    resetAdsConnect() {
      if (this.currentAdsIdx < 1 || this.currentAdsIdx - 1 >= this.adsList.length) {
          this.currentAdsConnectType = LINK_TYPE.Sale.key;
          this.currentAdsConnectData = '';
        return;
      }

      let adsItem = this.adsList[this.currentAdsIdx - 1];
      if (adsItem == null) {
        return;
      }
      this.currentAdsConnectType = adsItem.f_connect_type;
      this.currentAdsConnectData = adsItem.f_connect_value;
    }
  },
  mounted() {
    this.getHomeSetting();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';

.fixbutton {
  width:7em;
  margin-left:1em;
}

textarea {
  border: solid 1px $border;
}

.input-group>input {
  border-left :none;
}

button{
  font-size:0.8em;
  padding:0.5em 0.8em 0.5em 0.8em;
}

.pre-img-div {
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  border: solid 1px $border;
  border-radius: 0.25rem;
}

::placeholder{
  color: $text;
}

.primary{
  height: 33px;
  width: 64px;
  background-color: #0840ba;
  color: white;
  font-size: 14px;
  font-family: $korean_gd_15_r;
  padding-left: 0;
  padding-right: 0;
}
.reset_btn{
  @extend .primary;
  background-color: #cf0000;
}
.reset_btn1{
  @extend .reset_btn;
  width: 83px;
}

.delete_btn{
  @extend .primary;
  background-color: #bababa;
}

.small{
  font-size: 14px;
  font-family: $korean_gd_13_r;
  height: 33px;
  padding-left: 9px;
  padding-right: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminAd.vue